<template>
  <div v-if="isRelevant" class="wt-video-poster-toggle">
    <wt-toggle
      :label-left="'assetViewsMessages.SET_AS_THUMBNAIL' | culture"
      v-model="isVideoPoster"
      @toggle="$_onToggle"
    />
  </div>
</template>

<script>
import app from 'app';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'wt-video-poster-toggle',

  props: {
    asset: { type: Object, required: true },
  },

  data() {
    return {
      isVideoPoster: app.storyController.isVideoPoster(this.$props.asset),
    };
  },

  computed: {
    ...mapState('assetEditor', ['openedFrom']),

    isRelevant() {
      return (
        !app.assetType.isINFOGRX(this.asset) &&
        !app.assetType.isSOCIAL(this.asset) &&
        !app.assetType.isGIF(this.asset) &&
        !app.assetType.isWALLPAPER(this.asset) &&
        !app.assetType.isSOCIALFRAGMENT(this.asset) &&
        !app.assetType.isVIDEO(this.asset) &&
        !this.isUningestedAsset
      );
    },

    isUningestedAsset() {
      return (
        /asset-gallery/.test(this.openedFrom) &&
        app.assetType.isDynamicProvider(this.asset)
      );
    },
  },

  methods: {
    ...mapActions('assetEditor', ['fireAnalyticsEvent']),

    $_onToggle() {
      if (this.isVideoPoster) {
        this.fireAnalyticsEvent({ name: 'setAsThumbnail' });
        app.storyController.story.setVideoPosterAuto(this.$props.asset);
      } else {
        app.storyController.story.clearVideoPoster();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wt-video-poster-toggle {
  display: inline-flex;
  justify-content: space-between;
  font-size: 14px;
}
</style>
